import {
  GetGeoLocationDocs,
  GetGeoLocationMachine,
} from './GetGeoLocationMachine';
import { GenericTypes } from '_core/domain/Utils/Generic/Types';

const onGetGeoLocation: GenericTypes = {
  machine: GetGeoLocationMachine,
  docs: GetGeoLocationDocs,
  order: 1,
};

export default { onGetGeoLocation };
